import * as React from "react";
import { useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { ModalComponent } from "shared/components/modal/modal";
import { ICustomerAddressModel } from "states/customer-address/customer-address.models";
import { AddressViewItem } from "./address-view";
interface ISelectBillingAddress {
  addresses: ICustomerAddressModel[];
  onChange: (id: number) => void;
  value?: number;
}
export const SelectBillingAddress = ({
  addresses,
  value,
  onChange,
}: ISelectBillingAddress) => {
  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [selectedAddress, setSelectedAddress] = useState<ICustomerAddressModel>(
    {} as ICustomerAddressModel
  );
  const handleOpenModal = () => {
    setIsOpen(true);
  };
  const handleCloseModal = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    if (value) {
      let address = addresses?.find((m) => m.id === value);
      if (address !== undefined) {
        setSelectedAddress(address);
      }
    } else if (!value && addresses.length > 0) {
      let address = addresses[0];
      onChange(address.id);
      setSelectedAddress(addresses[0]);
    }
  }, [addresses]);
  return (
    <React.Fragment>
      <button
        onClick={handleOpenModal}
        className="btn--default w-full flex justify-between content-center items-center"
      >
        <span>
          {" "}
          {selectedAddress?.addressInfo?.street !== undefined ? (
            <AddressViewItem model={selectedAddress} isView={true} />
          ) : (
            "Select billing address"
          )}{" "}
        </span>{" "}
        <FontAwesomeIcon icon={faChevronRight} />
      </button>
      <ModalComponent
        width={`100%`}
        height={`100%`}
        isModal={false}
        className="w-full bg-white rounded-2xl"
        isCustomizeFooter={true}
        onCloseModal={handleCloseModal}
        isOpenModal={modalIsOpen}
        title={`Billing Address`}
      >
        <div className="p-4">
          {addresses?.map((m) => (
            <div
              onClick={() => {
                setSelectedAddress(m);
                onChange(m.id);
                handleCloseModal();
              }}
              className={`item-address mb-2 p-3  rounded-md shadow-lg  py-4 w-full cursor ${
                m.id === selectedAddress?.id ? "active" : ""
              }`}
            >
              <AddressViewItem model={m} key={m.id} />
            </div>
          ))}
        </div>
      </ModalComponent>
    </React.Fragment>
  );
};
